import gql from "graphql-tag";

export const SYSTEM_USERS = gql`
    query SYSTEM_USERS($page: Int!, $perPage: Int!, $searchKeyword: String, $isStaff: Boolean) {
        users (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, isStaff: $isStaff) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                id,
                publicId,
                firstName,
                lastName,
                name,
                email,
                phoneNumber,
                isActive,
                isStaff,
                isSuperuser,
                roles {
                    id,
                    name
                },
                profile {
                    id,
                    idNumber,
                    kraPin,
                    nhif,
                    nssf,
                    physicalAddress,
                    poBox,
                    dob,
                    createdAt,
                    updatedAt
                }
            }
        }
    }
`;

export const SIMPLE_SYSTEM_USERS = gql`
    query SIMPLE_SYSTEM_USERS($page: Int!, $perPage: Int!, $searchKeyword: String, $isStaff: Boolean) {
        users (page: $page, perPage: $perPage, searchKeyword: $searchKeyword, isStaff: $isStaff) {
            page,
            pages,
            total,
            nextPage,
            previousPage,
            hasNext,
            hasPrevious,
            objects {
                id,
                publicId,
                name,
            }
        }
    }
`;

export const SINGLE_USER = gql`
    query SINGLE_USER($id: String!, $currentPage: Int, $userActivityCurrentPage: Int) {
        user (id: $id) {
            id,
            publicId,
            avatar
            firstName,
            lastName,
            email,
            phoneNumber,
            isActive,
            isStaff,
            isSuperuser,
            createdAt,
            updatedAt,
            lastLogin,
            roles {
                id,
                name
            },
            permissionsPaginated (page: $currentPage, perPage: 15) {
                page,
                pages,
                total,
                nextPage,
                previousPage,
                hasNext,
                hasPrevious,
                objects {
                    id,
                    name,
                    codename
                }
            },
            profile {
                id,
                idNumber,
                kraPin,
                nhif,
                nssf,
                physicalAddress,
                poBox,
                dob,
                createdAt,
                updatedAt
            }
            activityPaginated (page: $userActivityCurrentPage, perPage: 45) {
                page,
                pages,
                total,
                nextPage,
                previousPage,
                hasNext,
                hasPrevious,
                objects {
                    activityMessage,
                    activityDate,
                }
            }
        }
    }
`;

export const ADD_SYSTEM_USER = gql`
    mutation ADD_SYSTEM_USER($roles: [RoleInputType], $user: UserInputType){
        adminUser(user: $user, roles: $roles) {
            user {
                id,
                publicId,
                firstName,
                lastName,
                email,
                phoneNumber
            }
        }
    }
`;

export const UPDATE_SYSTEM_USER = gql`
    mutation UPDATE_SYSTEM_USER($id: ID!,$roles: [RoleInputType], $user: UserInputType){
        adminUser(id: $id, user: $user, roles: $roles) {
            user {
                id,
                publicId,
                firstName,
                lastName,
                email,
                phoneNumber
            }
        }
    }
`;

export const ME = gql`
    query ME {
        me {
            avatar
            firstName,
            lastName,
            name,
            email,
            phoneNumber,
            profile {
                idNumber,
                kraPin,
                nhif,
                nssf,
                physicalAddress,
                poBox,
            }
        }
    }
`;
